define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dgrid/List",
	"dgrid/extensions/DijitRegistry",
	"csi",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/dgrid/More",
	"csi/html",
	"csi/html/Rule",
	"csi/locale",
	"csi/page/SearchManager",
	"csi/reflection",
	"csi/utility/routerUtility",
	"dojo/text!csi/templates/card.html"
], function(declare, lang, List, GridDijitRegistry, csi, _, Controller, More, html, Rule, locale, SearchManager, reflection, {getLocationForUrl}, template) {

	var _grid = null;

	return declare(Controller, {
		process: function() {
			// summary: render search results using grid
			var ctx = this.widget.getContext(csi.EMPTY_URL);
			var form = this.actionWidget;
			var store = form.store;
			var type = form.searchType;

			ctx.bPopup = true;
			ctx.bReserveClick = true;
			ctx.cache = store.cachingStore;
			ctx.prefImageSize = reflection.IMAGE_SIZE_SMALLEST;
			ctx.setReadOnly(true);

			var imgRule = {
				// Add the rule to fix IE bug whenever the image doesn't exist
				ImageRule: lang.mixin(new Rule(), {
					m_class: html.CSS_HIDE,
					m_exp: "!validValue('Images')"
				})
			};

			var defs = lang.mixin(SearchManager.getCardItemDefs(type, null, null, true, true), imgRule);

			// render data on each cell with same template as lastVisited
			var _renderRow = function(item, options) {
				var rowNode = html.templateToHtml(ctx.setNode(item), template, defs);

				if (item.$URL) {
					html.createRowAnchor(rowNode, getLocationForUrl(item.$URL), locale.getNodeName(item));
				}

				return rowNode;
			};

			this.setProgress();

			if (_grid) {
				_grid.set("renderRow", _renderRow);
				_grid.set("store", store);
			} else if (!dijit.byId("searchResultsGrid")) {
				// create grid for search; use infiniteScroll to access the scroll functionality of More extension
				_grid = new (declare([List, More, GridDijitRegistry]))({
					id: "searchResultsGrid",
					"class": "csi-grid-tableView csi-search-results-grid-views",
					showHeader: false,
					showFooter: true,
					showTotal: true,
					sort: false,
					infiniteScroll: true,
					loadingMessage: locale.resource("LoadingEllipsis"),
					renderRow: _renderRow,
					store: store
				}, form.galleryResultNode);

				_grid.startup();

				_grid.on(".dgrid-row:click", function(event) {
					form.hideSearchResults();
				});
			}

			this.postProcess(true);
		}
	});
});